import { Box, Grid, Typography } from '@material-ui/core';
import { Button, FieldLabel, StandardDialog, createSelectField, createTextField } from '@roc/ui';
import { format, parse } from 'date-fns';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react';
import { creditPullTierLabel } from '../../types/creditPullTiersTypes';
import { useCreditPullTiersSettingsStore } from '../../hooks/useCreditPullTiersStore';

const formatHistoryDate = (dateStr: string) => {
  const parsed = parse(dateStr, 'MM/dd/yyyy HH:mm:ss.SSS', new Date());
  return format(parsed, 'MMMM d, yyyy');
};

export const TierAssignmentDialog = observer(() => {
  const { creditPullTiersStore } = useCreditPullTiersSettingsStore();
  const { tierAssignmentStore, tiers } = creditPullTiersStore;
  const { isOpen, formStore, lenderDetail } = tierAssignmentStore;

  const handleClose = () => tierAssignmentStore.closeDialog();

  const tierOptions = tiers.map(t => ({
    label: creditPullTierLabel[t.tier],
    value: t.tier,
  }));

  const dialogContent = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {createTextField({
          store: formStore,
          fieldName: 'lenderName',
          label: 'TPO Name',
          testId: 'tierAssignmentLenderName',
          disabled: true,
        })}
      </Grid>
      <Grid item xs={12}>
        {createSelectField({
          store: formStore,
          fieldName: 'currentTier',
          label: 'Current Tier',
          testId: 'tierAssignmentCurrentTier',
          options: tierOptions,
        })}
      </Grid>
      {lenderDetail && (
        <Grid item xs={12}>
          <FieldLabel>
            Audit History
          </FieldLabel>
          <Box
            maxHeight={180}
            overflow="auto"
            border="1px solid #e0e0e0"
            borderRadius={4}
            p={1.5}
          >
            {lenderDetail.history.map(h => (
              <Typography key={h.historyId} variant="body1" style={{ marginBottom: 8 }}>
                Moved to {creditPullTierLabel[h.newTier]} by {h.lastUpdatedBy} on {formatHistoryDate(h.lastUpdatedDate)}.
              </Typography>
            ))}
            <Typography variant="body1">
              TPO is on Tier 1 by default.
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );

  const dialogActions = (
    <Box display="flex" justifyContent="flex-end" width="100%">
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClose}
        testId="tierAssignmentCancelButton"
        style={{ marginRight: 8 }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => flowResult(tierAssignmentStore.saveTierAssignment())}
        testId="tierAssignmentSaveButton"
      >
        Save
      </Button>
    </Box>
  );

  return (
    <StandardDialog
      open={isOpen}
      title="TPO Credit Pull Details"
      subTitle="Changes will apply to the selected TPO only."
      maxWidth="sm"
      fullWidth
      handleClose={handleClose}
      dialogContent={dialogContent}
      dialogActions={dialogActions}
      removeContentBox
    />
  );
});
